module.exports = __webpack_public_path__ + "media/images/landkit/icons/payment-methods/amex-153cfc92d1bf8bc993185eaf323541a9.svg";